import * as React from 'react';

import { useDebounceFn } from 'ahooks';
import { Button, Col, Form, Input, Row } from 'antd';

import { PlusOutlinedIcon, RichTextEditor } from 'components';
import { useProductCommentAction, useProductCommentValue } from 'context';
import { inputRule, randomId } from 'utils';

type FieldType = Pick<ReturnType<typeof useProductCommentValue>, 'content'> &
  Record<string, string>;

const ProductCommentFormContent = () => {
  const { content = '', replies = [], ownerType } = useProductCommentValue();
  const action = useProductCommentAction();

  const { run: debounceUpdateReplies } = useDebounceFn(
    (debouncedContent: string, debouncedIndex: number) => {
      action({
        type: 'UPDATE_PRODUCT_COMMENT_REPLIES',
        payload: {
          replies: replies.map((reply, index) =>
            debouncedIndex === index
              ? {
                  ...reply,
                  content: debouncedContent,
                }
              : reply,
          ),
        },
      });
    },
  );

  if (!ownerType) return <React.Fragment />;

  return (
    <Row className='p-6 pb-1'>
      <Col span={24}>
        <Form.Item<FieldType>
          label='دیدگاه کاربر'
          name='content'
          rules={[inputRule.required, inputRule.string]}
          initialValue={content}
        >
          <Input.TextArea rows={4} placeholder='دیدگاه کاربر را ویرایش کنید' />
        </Form.Item>
      </Col>
      <Col span={24}>
        <Form.Item<FieldType>>
          <Button
            block
            color='primary'
            variant='outlined'
            icon={<PlusOutlinedIcon />}
            onClick={() => {
              const newReply = {} as (typeof replies)[number];

              action({
                type: 'UPDATE_PRODUCT_COMMENT_REPLIES',
                payload: {
                  replies: [...replies, newReply],
                },
              });
            }}
          >
            افزودن پاسخ ادمین
          </Button>
        </Form.Item>
      </Col>
      <React.Fragment>
        {replies.map(({ id = randomId(), content = '' }, index) => (
          <Col key={id} span={24}>
            <Form.Item<FieldType>
              label='پاسخ ادمین'
              extra='در صورت خالی بودن این فیلد، پاسخ ادمین پس از ذخیره حذف خواهد شد.'
              name={`reply-${index}`}
            >
              <RichTextEditor
                ownerType={ownerType}
                options={{
                  content,
                  onUpdate: ({ editor }) => {
                    debounceUpdateReplies(editor.getHTML(), index);
                  },
                }}
                config={{
                  placeholder: {
                    placeholder: 'پاسخ ادمین را وارد کنید',
                  },
                }}
              />
            </Form.Item>
          </Col>
        ))}
      </React.Fragment>
    </Row>
  );
};

export { ProductCommentFormContent };
